/*
 * Copyright (c) 2025.
 * This code and its derivatives belong to BETICA LTD and may not be copied, reproduced, amended or used in any way without the permission of BETICA LTD
 * @author torrejonv
 *
 */

import isEmpty from "lodash.isempty";

export function isDefined(value) {
  return typeof value !== "undefined";
}

export function isNotEmpty(value) {
  return !isEmpty(value);
}
